import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_API_PATHS } from 'src/assets/constants/apiPaths';
import { BaseApiService } from '../base-api/base-api.service';

@Injectable({
  providedIn: 'root'
})
export class EmailActionService {
  constructor(
    private readonly baseApiService: BaseApiService
  ) { }

  /**
   * downloadFullForm - Method to download the full form.
   * @param data - The data to be sent in the request body.
   * @returns An Observable that emits the response from the server.
   */
  downloadFullForm(data: any): Observable<any> {
    const options = {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'json' as const
    };

    return this.baseApiService.post(GLOBAL_API_PATHS.downloadFullForm, data, options);
  }

  /**
   * performRiskAction - Method to perform an action on a risk.
   * @param requestBody - The request body containing the action details.
   * @returns An Observable that emits the response from the server.
   */
  performRiskAction(requestBody: any): Observable<any> {
    return this.baseApiService.post(GLOBAL_API_PATHS.accept_decline_risk, requestBody);
  }
}
